module.exports = __webpack_public_path__ + "static/media/java-expert.eedf8870.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/java-expert.png
// module id = 1294
// module chunks = 146